import { render, staticRenderFns } from "./VaPageLayout.vue?vue&type=template&id=7a5b9212&"
import script from "./VaPageLayout.vue?vue&type=script&lang=js&"
export * from "./VaPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./VaPageLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports